export default __webpack_public_path__ + "13a539370938aca0477072a1f454ba61.png";